import {
  ASSEMBLY_CATALOGUE_ALT,
  ASSEMBLY_CATALOGUE_IMAGE,
  ASSEMBLY_CATALOGUE_IMAGE_LANDSCAPE,
  ASSEMBLY_CATALOGUE_LANDSCAPE_MEDIA,
} from "../config/catalogue";

/** Responsive assembly catalogue: portrait JPEG on mobile, landscape PNG on tablet/desktop. */
export default function AssemblyCataloguePicture({ className, loading = "lazy" }) {
  return (
    <picture>
      <source
        media={ASSEMBLY_CATALOGUE_LANDSCAPE_MEDIA}
        srcSet={ASSEMBLY_CATALOGUE_IMAGE_LANDSCAPE}
        type="image/png"
      />
      <img
        src={ASSEMBLY_CATALOGUE_IMAGE}
        alt={ASSEMBLY_CATALOGUE_ALT}
        className={className}
        loading={loading}
        decoding="async"
      />
    </picture>
  );
}
